import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types'
import { Row, Col } from 'reactstrap';
import { BASE_URL, API } from 'CONST';
import { handleKey } from 'helpers/helpers';
import EditLineModal from './EditLineModal';
import { get, rDelete} from '../helpers/requests';
import GenericDetailCard from './GenericDetailCard';
import DetailCard from './DetailCard';
import MovimientoListDetail from './MovimientoListDetail';
import WarningModal from './UI/WarningModal';



const RowCardsGroup = ({ grupoId }) => {
  const [lineaGrupo, setLineaGrupo] = useState(undefined);
  const [aumento, setAumento] = useState(false);
  const [activeLine, setActiveLine] = useState('');
  const [activeData, setActiveData] = useState(undefined)
  const [borrador, setBorrador] = useState(undefined);
  const [update, setUpdate] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [approvedSuccess, setApprovedSuccess] = useState(false);
  const [activeMovement, setActiveMovement] = useState(false);

  const [confirmModal, setConfirmModal] = useState({
    isOpen: false,
    toggle: () => {},
    handleOk: () => {},
    loading: false,
    okBtnText: '',
    confirmMsg: '',
  });

  const getLineaGrupo = () => {
    get(`${BASE_URL}${API.lineasGarantiaGrupo}linea_por_grupo?grupo_id=${grupoId}`)
    .then((response) => {
      setLineaGrupo(response);
    })
  }

  useEffect(() => {
    if( grupoId ) {
      getLineaGrupo();
    }
  }, [])

  const updateFunc = () => {
    setUpdate((prevState) => !prevState);
  }

  const resetData = () => {
    setApprovedSuccess(false);
  }

  const resetBorrador = () => {
    setBorrador(undefined);
  }

  useEffect(() => {
    if (approvedSuccess) {
      getLineaGrupo();
      resetData();
    }
    if (!editModalOpen) {
      resetBorrador();
    }
  }, [editModalOpen, approvedSuccess]);

  const handleModal = () => {
    setEditModalOpen(!editModalOpen);
  }

  const handleView = (e, i) => {
    e.preventDefault();
    resetData();
    setActiveData(i.nemotecnico);
  }

  const handleEdit = (e, node, newAumento) => {
    e.preventDefault();
    const newActiveLine = {...node};
    newActiveLine.monto = lineaGrupo.balance[node.nemotecnico];
    setAumento(newAumento);
    setActiveLine(newActiveLine);
    setEditModalOpen(true);
  }

  const handleLineSuccess = (data) => {
    setActiveData(data);
    setEditModalOpen(false);
    updateFunc();
    getLineaGrupo();
    resetData();
  };

  const handleEditBorrador = (e, newBorrador, line) => {
    e.preventDefault();
    const newActiveLine = {...line};
    const isAumento = newBorrador.tipo_cambio.id ===1;
    newActiveLine.monto = newBorrador.balance[line.nemotecnico];
    setAumento(isAumento);
    setBorrador(newBorrador);
    setActiveLine(newActiveLine);
    setEditModalOpen(true);
  }

  const toggleConfirmationModal = () => {
    setConfirmModal((prevState) => ({
      ...prevState,
      isOpen: !prevState.isOpen,
    }));
  }

  const handleDeleteMovementSubmit = () => {
    setConfirmModal((prevState) => ({
      ...prevState,
      loading: true,
    }));
    rDelete(`${BASE_URL}${API.movimientosGrupo}${activeMovement.id}/`).then(() => {
      updateFunc();
      getLineaGrupo();
      setConfirmModal((prevState) => ({
        ...prevState,
        loading: false,
        isOpen: false,
      }));
    });
  }

  const updateConfirmationModal = (mode) => {
    const newConfirmModal = {
      isOpen: true,
      loading: false,
    };
    switch (mode) {
      case 'delete-movement':
        newConfirmModal.toggle = toggleConfirmationModal;
        newConfirmModal.handleOk = handleDeleteMovementSubmit;
        newConfirmModal.okBtnText = 'Eliminar';
        newConfirmModal.confirmMsg = 'Estás por eliminar este movimiento';
        break;
      default:
        break;
    }
    setConfirmModal(newConfirmModal);
  };

  const activeMovementSetter = (e, newActiveMovement) => {
    e.preventDefault();
    setActiveMovement(newActiveMovement);
  }

  useEffect(()=>{
    if(activeMovement){
      updateConfirmationModal('delete-movement');
    }
  },[activeMovement])

  return (
    <div>
      {editModalOpen && lineaGrupo && (
        <EditLineModal
          aumento={aumento}
          afianzado={lineaGrupo.grupo}
          borrador={borrador}
          handleModal={handleModal}
          id={lineaGrupo.id}
          linea={activeLine}
          lineaGarantia={lineaGrupo.id}
          lineSuccess={handleLineSuccess}
          modalOpen
          isGrupo
        />
      )}

      <WarningModal
        isOpen={confirmModal.isOpen}
        toggle={confirmModal.toggle}
        handleOk={confirmModal.handleOk}
        loading={confirmModal.loading}
        okBtnText={confirmModal.okBtnText}
        confirmMsg={confirmModal.confirmMsg}
      />

      { lineaGrupo && (
        <Row className="cards-container">
          <Col sm="2" xs="4">
            <DetailCard
              key={1}
              detail={lineaGrupo}
              handleEdit={handleEdit}
              handleView={handleView}
              node={{
                tipo_id: 1,
                label: 'Exposición Máxima',
                nemotecnico: 'exposicion_maxima'
              }}
            />
          </Col>
          <Col sm="2" xs="4">
            <DetailCard
              key={1}
              detail={lineaGrupo}
              handleEdit={handleEdit}
              handleView={handleView}
              node={{
                tipo_id: 2,
                label: 'Línea Máxima',
                nemotecnico: 'linea'
              }}
            />
          </Col>
          <Col sm="2" xs="4">
            <GenericDetailCard
              title='Suma de Exposiciones'
              value={lineaGrupo.balance.suma_exposiciones}
            />
          </Col>
          <Col sm="2" xs="4">
            <GenericDetailCard
              title='Suma de Líneas'
              value={lineaGrupo.balance.suma_lineas}
            />
          </Col>
          <Col sm="2" xs="4">
            <GenericDetailCard
              title='Cúmulo del Grupo'
              value={lineaGrupo.balance.suma_cumulos}
            />
          </Col>
          <Col sm="2" xs="4">
            <GenericDetailCard
              title='Cupo Restante Grupo'
              value={lineaGrupo.balance.cupo_restante ? lineaGrupo.balance.cupo_restante : 0}
            />
          </Col>
        </Row>
      )}
      <br />
      <br />
      <Row>
        <Col>
          {activeData && (
            <MovimientoListDetail
              handleUpdate={updateFunc}
              id={lineaGrupo.id}
              movimiento={handleKey(activeData)}
              handleEdit={handleEditBorrador}
              setActiveMovement={activeMovementSetter}
              afianzado={lineaGrupo.grupo}
              update={update}
              isGrupo
            />
          )}
        </Col>
      </Row>
    </div>
  )
}

RowCardsGroup.propTypes = {
  grupoId: PropTypes.number.isRequired,
}


export default RowCardsGroup;